import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Badge, Box, Button, Tab, Tabs } from "@mui/material";
import POList from "./po-list";
import "./index.scss";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { FINANCE_V2_HOSTNAME } from "../../../common-utilities/utils/end-points";
import { FINANCE_REST_URLS } from "../../../common-utilities/utils/end-points/finance-v2";
import POApprovalList from "./po-approval-list";
import { isCreateAllowed, isProcurementUser, isBaseUserRole, isPrPoRcRole } from "../../utils/common-utils";
import { checkUserRight } from "../../utils/utils";
import { getOfflineData } from "../../utils/offline-services";
import CreatePOChooserModal from "./create-po-chooser-modal";
import IndependentPOModal from "./independent-po-modal";
import CreatePOFromPRModal from "./create-po-from-pr-modal";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const PurchaseOrder = () => {
  const [createPOStep, setCreatePOStep] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const openTabIndex = searchParams.get("subIndex");
  const mainTabIndex = searchParams.get("index");
  const [value, setValue] = useState(+openTabIndex || 0);
  const [noOfPendingPo, setNoOfPendingPo] = useState(0);
  const [noOfReconsiderPo, setNoOfReconsiderPo] = useState(0);
  const userDetails = getOfflineData("user") || {};

  const handleChange = (event, newValue) => {
    setSearchParams({
      index: mainTabIndex || 0,
      subIndex: newValue,
    });
    setValue(newValue);
  };
  const getPendingPo = () => {
    invokeApi(
      HTTP_METHODS.POST,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.GET_MY_APPROVALS}`,
      null,
      {
        approvalType: "po_approval",
        status: "approval_in_progress",
      }
    )
      .then((response) => {
        if (response.message) {
        } else {
          setNoOfPendingPo(response?.length);
        }
      })
      .catch((err) => {});
  };
  const getReconsiderPo = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.PO}`,
      null,
      { status: "reconsider", limit: 1000 }
    )
      .then((response) => {
        if (!response.message) {
          setNoOfReconsiderPo(response?.results?.length || 0);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    const openTabIndex = searchParams.get("subIndex");
    if (+openTabIndex === 6 && !checkUserRight("po.approveReject")) {
      setValue(5);
    }
  }, []);
  useEffect(() => {
    getPendingPo();
    getReconsiderPo();
  }, []);
  return (
    <div className=" finance-v2-rm-pt finance-v2-budget-list">
      <div className="tabs-section">
        <Box>
          <Tabs
            variant="scrollable"
            value={value}
            onChange={handleChange}
            sx={{
              borderBottom: "1px solid #DDE2EC",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": {
                color: "#5B6E8A",
                minWidth: "unset",
                borderRadius: "20px",
                margin: "0 2px",
                textTransform: "none",
                "& .MuiBadge-root": {
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                },
                "& .MuiBadge-badge": {
                  position: "relative",
                  transform: "none",
                  top: "auto",
                  right: "auto",
                  background: "transparent",
                  color: "#007A42",
                  minWidth: "unset",
                  height: "auto",
                  padding: 0,
                  fontSize: "0.68rem",
                  fontWeight: 700,
                  lineHeight: 1,
                  borderRadius: 0,
                  boxShadow: "none",
                  "&.MuiBadge-invisible": { display: "none" },
                },
              },
              "& .Mui-selected": {
                color: "#005F35 !important",
                background: "#EAF4EE",
                "& .MuiBadge-badge": {
                  background: "#005F35",
                  color: "#fff",
                  minWidth: "16px",
                  height: "16px",
                  padding: "0 3px",
                  fontSize: "0.65rem",
                  fontWeight: 700,
                  borderRadius: "50%",
                },
              },
            }}
            TabIndicatorProps={{ sx: { display: "none" } }}
          >
            <Tab label="Draft PO List" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            <Tab label="In Progress PO List" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            <Tab label="Open PO List" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            <Tab label="Approved  PO List" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            <Tab
              label={
                <Badge badgeContent={noOfReconsiderPo} color="primary">
                  Reconsider PO List
                </Badge>
              }
              sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} 
              />
            <Tab label="All PO List" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            <Tab
              label={
                <Badge badgeContent={noOfPendingPo} color="primary">
                  Pending Actions
                </Badge>
              }
              sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} 
            />
          </Tabs>
        </Box>
        {(isCreateAllowed("po") || parseInt(userDetails?.id) === 2629) && (
          <Button
            variant="outlined"
            onClick={() => {
              // Procurement & Supply Chain and regular department "user" accounts can convert
              // a PR into a PO (the picker itself only ever lists PRs the backend scopes them
              // to -- see getPurchaseRequests). Store (and any other role) has no PR-based
              // option at all, so it skips the PO-type chooser and goes straight to the
              // Independent PO flow.
              // setCreatePOStep(isProcurementUser() || isBaseUserRole() ? "chooser" : "independent");
              // Plain "user" (P&SC included) is back to Independent PO only -- no "Create PO
              // from PR"; PR PO RC takes over the old "user" PR-based option.
              setCreatePOStep(
                !isBaseUserRole() && (isProcurementUser() || isPrPoRcRole()) ? "chooser" : "independent"
              );
            }}
          >
            Create PO
          </Button>
        )}
      </div>
      <TabPanel value={value} index={0}>
        <POList status="draft" />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <POList status="approval_in_progress" />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <POList status="all" allowInward />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <POList status="approved" />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <POList status="reconsider" />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <POList status="all" />
      </TabPanel>
      <TabPanel value={value} index={6}>
        {checkUserRight("po.approveReject") ? (
          <POApprovalList
            searchPlaceHolder="Search by Po Number"
            approvalType="po_approval"
            status="approval_in_progress"
          />
        ) : (
          "Not authorized to take action on purchase order"
        )}
      </TabPanel>

      {createPOStep === "chooser" && (
        <CreatePOChooserModal
          onClose={() => setCreatePOStep(null)}
          onChooseIndependent={() => setCreatePOStep("independent")}
          onChoosePR={() => setCreatePOStep("choose-pr")}
        />
      )}
      {createPOStep === "independent" && (
        <IndependentPOModal
          onClose={() => setCreatePOStep(null)}
          mainTabIndex={mainTabIndex}
          value={value}
        />
      )}
      {createPOStep === "choose-pr" && (
        <CreatePOFromPRModal onClose={() => setCreatePOStep(null)} />
      )}
    </div>
  );
};

export default PurchaseOrder;
